import { createContext, useContext } from 'react'

export const FEATURE_GATE_CONTEXT_KEYS = {}

export const FEATURE_GATE_HEADERS = {}

export const FeatureGateContext = createContext(undefined)

export const getFeatureGateValue = (gates, flag) => gates?.[flag] ?? false

const getHeaderValue = (headers, headerName) => {
  if (typeof headers?.get === 'function') {
    return headers.get(headerName)
  }

  return headers?.[headerName]
}

export const getFeatureGatesFromHeaders = (headers = {}) => (
  Object.entries(FEATURE_GATE_HEADERS).reduce((gates, [gateName, headerName]) => ({
    ...gates,
    [FEATURE_GATE_CONTEXT_KEYS[gateName]]: getHeaderValue(headers, headerName) === 'true',
  }), {})
)

export const useFeatureGate = (flag) => {
  const gates = useContext(FeatureGateContext)
  return getFeatureGateValue(gates, flag)
}
